import { useEffect } from 'react'
import { Route, Routes, Navigate, useLocation } from 'react-router-dom'
import RedirectHandler from './RedirectHandler'
import ToRedirect from './ToRedirect'
import logRedirect from '../../helper/RedirectLogger'
import PropTypes from 'prop-types'

const LoggedNavigate = ({ to, replace }) => {
	const location = useLocation()

	useEffect(() => {
		logRedirect('LoginRouter', {
			from: location.pathname + location.search,
			to,
			replace,
			action: 'React Router Navigate',
		})
	}, [location, to, replace])

	return <Navigate to={to} replace={replace} />
}

const LoginRouter = () => {
	const location = useLocation()

	useEffect(() => {
		logRedirect('LoginRouter', {
			currentPath: location.pathname,
			currentSearch: location.search,
			action: 'Route matched',
			referrer: document.referrer,
		})
	}, [location])

	return (
		<Routes>
			<Route path="/login" element={<ToRedirect />} />
			<Route path="/login/sso" element={<ToRedirect allowSSO />} />
			{/* <Route path="/login/resetpassword" element={<Login />} /> */}
			<Route path="/login/target" element={<RedirectHandler />} />
			<Route path="*" element={<LoggedNavigate to="/login" />} />
		</Routes>
	)
}

LoggedNavigate.propTypes = {
	to: PropTypes.string.isRequired,
	replace: PropTypes.bool,
}

export default LoginRouter
